import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'light' | 'dark' | 'navy';
}
export function Section({
  children,
  className = '',
  id,
  background = 'white'
}: SectionProps) {
  const bgColors = {
    white: 'bg-white text-gray-900',
    light: 'bg-gray-50 text-gray-900',
    dark: 'bg-gray-900 text-white',
    navy: 'bg-[#0B1C3E] text-white' // Deep Navy Blue
  };
  return <section id={id} className={`py-8 md:py-8 ${bgColors[background]} ${className}`} data-id="element-298">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl" data-id="element-299">{children}</div>
    </section>;
}